import { motion, AnimatePresence } from 'framer-motion';
import { X, Timer } from 'lucide-react';

interface POC48ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function POC48Modal({ isOpen, onClose }: POC48ModalProps) {
  if (!isOpen) return null;
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="bg-gradient-to-br from-slate-900 via-orange-900 to-slate-900 rounded-2xl max-w-5xl w-full my-8 border border-orange-500/30 shadow-2xl shadow-orange-500/20"
          >
            <div className="relative p-8 border-b border-orange-500/30">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl">
                    <Timer className="w-10 h-10 text-white" />
                  </div>
                  <div>
                    <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-red-400">
                      POC 48h - Règle d'Or
                    </h2>
                    <p className="text-gray-400 mt-1 text-lg">Mock data, 5 écrans, Go/No-Go</p>
                  </div>
                </div>
                <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-lg transition-colors">
                  <X className="w-6 h-6 text-gray-400" />
                </button>
              </div>
            </div>
            <div className="p-8 space-y-8 max-h-[calc(100vh-300px)] overflow-y-auto">
              <div className="bg-gradient-to-r from-orange-600/20 via-red-600/20 to-orange-600/20 rounded-xl p-8 border-2 border-orange-500/50">
                <h3 className="text-2xl font-bold text-center text-white mb-4">Règle POC 48h</h3>
                <p className="text-gray-300 text-center text-lg">
                  <strong className="text-white">Mock data, 5 écrans, Go/No-Go</strong>. 
                  Si on dépasse 48h, on re-cadre le projet.
                </p>
              </div>
              <div className="bg-gradient-to-br from-orange-500/10 to-red-500/10 rounded-xl p-6 border border-orange-500/30">
                <h4 className="text-xl font-bold text-white mb-4">KPI : ≤48h sur 95%</h4>
                <p className="text-gray-300">95% des POC doivent être livrés en 48h ou moins.</p>
              </div>
            </div>
            <div className="p-6 border-t border-orange-500/30 bg-slate-900/50">
              <div className="flex items-center justify-end">
                <button onClick={onClose} className="px-6 py-3 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-xl hover:from-orange-600 hover:to-red-600 transition-all duration-200 font-semibold shadow-lg shadow-orange-500/20 hover:shadow-orange-500/40 hover:scale-105">
                  Fermer
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}

